/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Layout from "../../components/Layout/layout";
import SpeakersCard from "../../components/SpeakersCard/SpeakersCard";

import speaker1 from "../../assets/images/ProfKyleRollins.jpeg";
import speaker2 from "../../assets/images/speaker2.jpg";
import speaker3 from "../../assets/images/speaker3.jpg";
import speaker4 from "../../assets/images/speaker4.png";
import speaker5 from "../../assets/images/speaker5.jpg";
import speaker6 from "../../assets/images/speaker6.jpeg";
import speaker7 from "../../assets/images/speaker7.jpeg";
import speaker8 from "../../assets/images/speaker8.jpeg";
import speaker9 from "../../assets/images/speaker9.jpeg";
import speaker10 from "../../assets/images/speaker10.jpeg";
import speaker11 from "../../assets/images/speaker11.jpeg";
import speaker12 from "../../assets/images/speaker12.png";
import speaker13 from "../../assets/images/prof_yasuda.jpg";
import speaker14 from "../../assets/images/ConfCoChair.jpg";

const PanelSpeaker = () => {
  const speakers = [
    // {
    //   name: "Prof. Asimaki Domniki",
    //   place: "California Institute of Technology, Pasadena, CA",
    //   note: "Analysis of strong motion data from 2015 Nepal earthquake",
    //   img: speaker4,
    //   link: "https://asimaki.caltech.edu/index.html",
    // },
    {
      name: "Prof. Choudhury D.",
      place: "IIT Bombay",
      note: "Seismic behaviour of CPRF system",
      img: speaker12,
      link: "https://www.civil.iitb.ac.in/faculty/details/prof-deepankar-choudhury",
    },
    {
      name: "Dr. Desai Chandrakant S.",
      place: "The University of Arizona, Tucson",
      note: "Liquefaction",
      img: speaker3,
      link: "https://www.u.arizona.edu/~csdesai/",
    },
    {
      name: "Prof. Elgamal Ahmed-Waeil",
      place: "University of California San Diego",
      note: "Multi-surface plasticity soil model for seismically induced liquefaction",
      img: speaker2,
      link: "https://www.researchgate.net/profile/Ahmed-Waeil-Elgamal",
    },
    {
      name: "Prof. Hazarika Hemanta",
      place: "Kyushu University",
      note: "Lateral Flow in Reclaimed Land due to Liquefaction during the 2024 Noto Peninsula Earthquake, Japan ~ Insights from Remote Sensing and Field Survey ~",
      img: speaker10,
      link: "https://kyushu-u.elsevierpure.com/en/persons/hemanta-hazarika",
    },
    {
      name: "Prof. Kaynia Amir M.",
      place: "NTNU",
      note: "Numerical Considerations in Assessing Earthquake Response of Offshore Monopiles ",
      img: speaker5,
      link: "https://www.ntnu.edu/employees/amir.kaynia",
    },
    {
      name: "Prof. Kokusho Takaji",
      place: "Chuo University, Tokyo, Japan",
      note: "Liquefaction Induced Flow Failures of Low-Gradient Sand Slopes with NP-Fines; Case Histories and Lab Tests",
      img: speaker7,
      link: "https://www.researchgate.net/profile/Takaji-Kokusho",
    },
    {
      name: "Prof. Foti Sebastiano",
      place: "Politecnico di Torino",
      note: "Will be updated soon",
      img: speaker14,
      link: "https://www.researchgate.net/profile/Sebastiano-Foti",
    },
    {
      name: "Prof. Madabhushi Gopal S P",
      place: "University of Cambridge",
      note: "Seismic performance of caisson foundations",
      img: speaker6,
      link: "https://www.researchgate.net/profile/Gopal-Madabhushi",
    },
    // {
    //   name: "Prof. Saitoh Masato",
    //   place: "Saitama University",
    //   note: "Advanced Dynamic Soil-Pile Interaction: Challenges in Elucidating the Effects of Nonlinearities on Frequency Dependency of Dynamic Stiffness and Its Modeling",
    //   img: speaker9,
    //   link: "https://www.researchgate.net/profile/Masato-Saitoh",
    // },
    {
      name: "Prof. Rollins Kyle",
      place: "Brigham Young University",
      note: "Predicting Gravel Liquefaction Using Dynamic Penetration Resistance and Shear Wave Velocity ",
      img: speaker1,
      link: "https://www.researchgate.net/profile/Kyle-Rollins",
    },
    {
      name: "Prof. Sitharam T.G.",
      place: "Indian Institute of Science Bangalore",
      note: "Engineering preparedness for disaster mitigation",
      img: speaker11,
      link: "https://scholar.google.com.sg/citations?user=OKug7KsAAAAJ&hl=en",
    },
    {
      name: "Prof. Towhata Ikuo",
      place: "University of Tokyo, Japan",
      note: "Instability of Mountain Slopes Undergoing Long-Term Effects of Fault Actio",
      img: speaker8,
      link: "https://scholar.google.com/citations?user=AEJtbtIAAAAJ",
    },
    {
      name: "Prof. Yasuda Susumu",
      place: "Prof. Emeritus of Tokyo Denki University",
      note: "Damage to Residential Areas caused by Liquefaction-induced Lateral Flow during the 2024 Noto Peninsula Earthquake and Selection of Appropriate Countermeasures",
      img: speaker13,
      link: "http://seags.ait.asia/news-announcements/prof-susumu-yasuda/",
    },
  ];

  speakers.sort((a, b) => {
    const firstNameA = a.name.split(" ")[1];
    const firstNameB = b.name.split(" ")[1];
    return firstNameA.localeCompare(firstNameB);
  });

  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10 ">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 bg-white z-20 mb-[5vh] relative mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] pb-4">
            PLENARY SPEAKERS
          </div>
          <div className="flex flex-wrap justify-between">
            {speakers.map((speaker, index) => (
              <a key={index} href={speaker.link}>
                <SpeakersCard
                  name1={speaker.name}
                  place1={speaker.place}
                  note1={speaker.note}
                  speaker1={speaker.img}
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PanelSpeaker;
